import { useUserContext } from '@/hooks/useUserContext';
import { useEffect, useMemo, useState } from 'react';
import { matchRoutes, RouteObject, useLocation, useOutlet, } from 'react-router-dom';
import { useTenant } from '@/contexts/TenantContext';
import {getErrorByStatusCode, getValidationErrorData, redirectToErrorPage} from '@/lib/ErrorHandler.ts';

interface Props {
  routes: RouteObject[];
}

const ProtectedRoutes = ({ routes }: Props): JSX.Element => {
  const location = useLocation();
  const outlet = useOutlet();
  const matchs = matchRoutes(routes, location.pathname);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const { tenant } = useTenant();
  const { user } = useUserContext();

  const routeData = useMemo(() => {
    if (!matchs) {
      return null;
    }
    const { route } = matchs[0];
    return route;
  }, [matchs]);

  useEffect(() => {
    if (!user) setIsAuthenticated(false);
    if (routeData) {
      const pathsValidation = new Map();
      pathsValidation.set('valuations', [
        'Administrator',
        'Valuations',
      ]);
      pathsValidation.set('rules', ['Administrator', 'Rules', 'RuleAnalysis','ReadOnly']);
      pathsValidation.set('variables', ['Administrator', 'Variables','ReadOnly']);
      pathsValidation.set('settings', ['Administrator','ReadOnly']);
      pathsValidation.set('domains', ['Administrator','ReadOnly']);

      const arrayValidation = pathsValidation.get(routeData.path);
      setIsAuthenticated(validatePermissions(arrayValidation))
    }
  }, [user]);

  useEffect(() => {

    if(!tenant?.trim()){
      const errorData = getValidationErrorData('Error.ClientNotFound');
      redirectToErrorPage(errorData);
    }

    if (!user && !isAuthenticated) {
      const errorData = getErrorByStatusCode(401);
      redirectToErrorPage(errorData);
    }
  }, [tenant, isAuthenticated]);

  const validatePermissions = (arrayValidation: any[]) => {
    return user?.roles?.some((role) => arrayValidation?.includes(role.systemName));
  };

  return <>{outlet}</>;
};

export default ProtectedRoutes;
